import React, { useState, useRef, useEffect } from 'react'
import _ from 'lodash'
import Dropdown, { MenuItem } from '@trendmicro/react-dropdown'
import DateRangePicker from 'react-bootstrap-daterangepicker'
import moment from 'moment'

import useOnClickOutside from '../../hooks/on_click_outside_div'

import 'bootstrap-daterangepicker/daterangepicker.css'
import '../../../static/css/daterangepicker.css'

import '@trendmicro/react-buttons/dist/react-buttons.css'
import '@trendmicro/react-dropdown/dist/react-dropdown.css'

const FilterDropdownComponent = ({
  filters,
  onSelectFilter
}) => {
  const [isOpen, setIsOpen] = useState(false) // filter dropdown state
  const [openedSubMenu, setOpenedSubMenu] = useState('')

  const filterDivRef = useRef()

  useOnClickOutside(filterDivRef, (event) => {
    const target = event.target
    if (target?.closest?.('.daterangepicker')) return
    setIsOpen(false)
  })

  useEffect(
    () => {
      if (!isOpen) {
        setOpenedSubMenu('')
      }
    },
    [isOpen]
  )

  const onToggle = () => {
    setIsOpen(!isOpen)
  }

  const onCustomDateApply = (event, picker) => {
    let dateObject = {
      filter_label: 'Date',
      filter_value: 'date_range',
      value: {
        startDate: picker.startDate,
        endDate: picker.endDate
      },
      label:
        moment(picker.startDate).format('DD MMM YYYY') +
        ' - ' +
        moment(picker.endDate).format('DD MMM YYYY'),
    }

    onSelectFilter(dateObject)
  }

  const onSelectFilterDropdown = (eventKey) => {
    if (eventKey.value === 'custom_date') {
      setOpenedSubMenu(eventKey.filter_value)
      return
    }
    onSelectFilter(eventKey)
  }

  const onClickCustomDateFilter = (e) => {
    e.stopPropagation()
  }

  const datePickerCallbackEvent = (e) => {
    if (e.type === 'apply' || e.type === 'cancel') {
      setOpenedSubMenu('')
      setIsOpen(false)
    }
  }

  return (
    <div
      onClick={onToggle}
      ref={filterDivRef}
    >
      <Dropdown
        open={isOpen}
        onToggle={() => { }}
        className="filter-class"
        style={{ display: 'flex' }}
      >
        <Dropdown.Toggle>
          <i className="fa fa-filter" />
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {_.map(filters, (filter, index) => (
            <MenuItem
              id={filter.value}
              className="filter-menu-item"
              key={index}
              open={openedSubMenu === filter.value}
            >
              {filter.name}
              {_.map(filter.menus, (menu, index) => {
                let event_key = {
                  label: menu.label,
                  value: menu.id ? { id: menu.id, role: menu.role } : menu.value,
                  filter_label: filter.name,
                  filter_value: filter.value
                }
                if (menu.value === 'custom_date') {
                  return (
                    <MenuItem
                      className="filter-menu-item custom-date"
                      key={index}
                      eventKey={event_key}
                      onClick={(e) => onClickCustomDateFilter(e)}
                      onSelect={onSelectFilterDropdown}
                    >
                      <DateRangePicker
                        initialSettings={{
                          drops: 'up',
                          maxDate: moment().endOf('day'),
                          minDate: moment().subtract(2, 'years'),
                          maxSpan: { days: 30 }
                        }}
                        onApply={onCustomDateApply}
                        onEvent={datePickerCallbackEvent}
                      >
                        <span className="date-label">Custom Range</span>
                      </DateRangePicker>
                    </MenuItem>
                  )
                } else {
                  return (
                    <MenuItem
                      className="filter-menu-item"
                      key={index}
                      eventKey={event_key}
                      onSelect={onSelectFilter}
                    >
                      {menu.label}
                    </MenuItem>
                  )
                }
              })}
            </MenuItem>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  )
}

export default FilterDropdownComponent
